import { Box, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';

declare global {
  interface WindowEventMap {
    beforeinstallprompt: BeforeInstallPromptEvent;
  }
}

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed'; platform: string }>;
}

const InstallPWA: React.FC = () => {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState<BeforeInstallPromptEvent | null>(null);

  useEffect(() => {
    const handler = (e: BeforeInstallPromptEvent) => {
      e.preventDefault();
      setSupportsPWA(true);
      setPromptInstall(e);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const onClick = async (evt: React.MouseEvent<HTMLButtonElement>) => {
    evt.preventDefault();
    if (!promptInstall) return;

    await promptInstall.prompt();
  };

  if (!supportsPWA) return null;

  return (
    <Button
      id="setup_button"
      aria-label="Install app"
      title="Nainstalovat aplikaci"
      onClick={onClick}
      variant="contained"
      color="success"
      size="large"
      startIcon={
        <Box component="img" src="/downloadAppLogo.svg" alt="Ke stažení logo" sx={{ width: 40, height: 30 }} />
      }
      sx={{
        backgroundColor: '#000',
        color: '#fff',
        '&:hover': {
          backgroundColor: '#333'
        }
      }}
    >
      Nainstalovat aplikaci
    </Button>
  );
};

export default InstallPWA;
